export enum PropertyType {
	Bungalow = 0,
	Detached = 10,
	Flat = 20,
	SemiDetached = 30,
	Studio = 40,
	Terraced = 50,
	Commercial = 60,
	Other = 99
}